import { IStoreAction, STORE } from '../generalTypes'
import { EarningsAction, IEarningsLoadListPayload } from './earningsActions'
import { EARNINGS_LOAD_LIST } from './earningsTypes'

const initState: { list: IEarningsLoadListPayload } = {
	list: {
		records: [],
		pagination: undefined,
		isLoading: false,
		isFailure: false
	}
}

export default (state = initState, action: EarningsAction | IStoreAction) => {
	switch (action.type) {
		case EARNINGS_LOAD_LIST.START:
			return {
				...state,
				list: {
					...state.list,
					isLoading: true,
					isFailure: false
				}
			}
		case EARNINGS_LOAD_LIST.DONE:
			return {
				...state,
				list: {
					...state.list,
					...action.payload,
					isLoading: false,
					isFailure: false
				}
			}
		case EARNINGS_LOAD_LIST.FAIL:
			return {
				...state,
				list: {
					...state.list,
					...action.payload,
					isLoading: false,
					isFailure: true
				}
			}
		case STORE.RESET:
			return initState
		default:
			return state
	}
}
